import React from "react";
import { CiCalendar, CiMonitor } from "react-icons/ci";

export const Services = () => {
  const services = [
    {
      name: "Event Management",
      text: "Launch and manage your events with ease.",
      icon: CiCalendar,
      link: "https://event.sari-sari.com",
      cardColor: "#F2F7FF", 
      iconBg: "#C4E2FF",
      iconColor: "#007BFF",
      cardClass: "card-blue",
    },
    {
      name: "Web Development",
      text: "Design and manage your event site with ease.",
      icon: CiMonitor,
      link: "https://www.sari-sari.com/",
      cardColor: "#F4FFF2",
      iconBg: "#D9FFC4",
      iconColor: "#00A859",
      cardClass: "card-green", 
    },
    {
      name: "Coming Soon Service",
      text: "Stay tuned for our upcoming offerings!",
      icon: CiMonitor,
      link: "",
      cardColor: "#FBF2FF",
      iconBg: "#E3C4FF",
      iconColor: "#8A2BE2",
      cardClass: "card-purple", // Custom class for color-specific styles
    },
  ];

  return (
    // Main section background and padding moved to CSS
    <div id="services" className="text-center services-section-bg">
      <div className="container">
        <div className="section-title">
          {/* Header styles moved to CSS */}
          <h2 className="services-title">OUR PRODUCTS</h2>
          {/* Paragraph styles moved to CSS */}
          <p className="services-subtitle">
            We offer a wide range of products tailored to your needs, delivered
            with excellence and efficiency.
          </p>
        </div>
        <div className="row justify-content-center">
          {services.map((service, i) => {
            const Icon = service.icon;

            return (
              <div
                key={`${service.name}-${i}`}
                className="col-lg-4 col-md-6 mb-4 d-flex"
              >
                {service.link ? (
                  <a
                    href={service.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="service-link-wrapper"
                  >
                    <div className={`service-card ${service.cardClass}`}>
                      <div
                        className="service-icon-wrapper"
                        style={{
                          backgroundColor: service.iconBg,
                          color: service.iconColor,
                        }}
                      >
                        <Icon className="service-icon" />
                      </div>

                      <div className="service-desc-container">
                        <h3 className="service-title">{service.name}</h3>
                        <p className="service-text">{service.text}</p>
                      </div>

                      <div className="learn-more-link">
                        <span>Learn More</span>
                        <span className="service-arrow">&rarr;</span>
                      </div>
                    </div>
                  </a>
                ) : (
                  <div className="service-link-wrapper service-link-wrapper--disabled" aria-disabled="true">
                    <div className={`service-card ${service.cardClass}`}>
                    <div
                      className="service-icon-wrapper"
                      style={{
                        backgroundColor: service.iconBg,
                        color: service.iconColor,
                      }}
                    >
                      <Icon className="service-icon" />
                    </div>

                    <div className="service-desc-container">
                      <h3 className="service-title">{service.name}</h3>
                      <p className="service-text">{service.text}</p>
                    </div>

                    <div className="learn-more-link">
                      <span>Learn More</span>
                      <span className="service-arrow">&rarr;</span>
                    </div>
                  </div>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};
